import React, { useEffect, useState } from "react";
import Card from "components/Card/Card";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Button,
} from "react-bootstrap";
import Select from "react-select";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Datetime from "react-datetime";
import {
  downloadClaimReports,
  getClaimOrganizationList,
} from "../../../api/purchaseOrder/ClaimReport/claimReport";
import moment from "moment";
import { claimReportTypeOption } from "./claimReport.Util";
import ScreenLoader from "views/Components/screenLoader";
import Swal from "sweetalert2";
import SubmmitedClaimErrorModal from "./SubmittedClaimsErrorModal/submmitedClaimErrorModal";
const ClaimReport = (props) => {
  const token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();

  const [organizationOption, setOrganizationOption] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState("");
  const [selectedOrganization, setSelectedOrganization] = useState();
  const [selectedReportType, setSelectedReportType] = useState();
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [errorValidate, setErrorValidate] = useState({
    organizationError: null,
    startDateError: null,
    endDateError: null,
    reportTypeError: null,
  });

  useEffect(() => {
    getClaimOrganizationListData();
  }, []);

  const getClaimOrganizationListData = async () => {
    getClaimOrganizationList(obj).then((res) => {
      const getClaimOrganizationOption = res.data.map((data) => {
        return {
          value: data.id,
          label: data.company_name,
        };
      });
      setOrganizationOption(getClaimOrganizationOption);
    });
  };

  const selectOrganization = (value) => {
    const removeError = errorValidate;
    setSelectedOrganization(value);
    setSelectedReportType(null);
    setSelectedStartDate("");
    setSelectedEndDate("");
    removeError.organizationError = null;
    setErrorValidate(removeError);
  };

  const selectStartDate = (date, type) => {
    const removeError = errorValidate;
    const selectedDateValue = moment(date).format("YYYY-MM-DD");
    if (type === "start") {
      setSelectedStartDate(selectedDateValue);
      removeError.startDateError = null;
    } else {
      setSelectedEndDate(selectedDateValue);
      removeError.endDateError = null;
    }
    setErrorValidate(removeError);
  };

  const handleOnReportTypeChange = (value) => {
    setSelectedReportType(value);
    const removeError = errorValidate;
    removeError.reportTypeError = null;
    setErrorValidate(removeError);
  };

  const onSubmit = async () => {
    let error = false;
    const validationError = errorValidate;
    const validationFields = {
      organization: selectedOrganization,
      reportType: selectedReportType,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
    };
    Object.entries(validationFields).map(([key, value]) => {
      if (!validationFields[key]) {
        error = true;
        validationError[`${key}Error`] = (
          <small className="text-danger">Field is required.</small>
        );
      }
    });
    setErrorValidate({ ...validationError });

    if (!error) {
      const reportBody = {
        start_date: selectedStartDate,
        end_date: selectedEndDate,
        organization_id: !!selectedOrganization ? selectedOrganization : "",
        type: !!selectedReportType ? selectedReportType : "",
      };
      setIsLoading(true);
      const downloadReport = await downloadClaimReports(obj, reportBody)
        .then((res) => {
          if (!!res.success) {
            const link = document.createElement("a");
            link.href = res.data;
            link.target = "_blank";
            link.setAttribute(
              "download",
              `report_${selectedStartDate}_${selectedEndDate}.pdf`
            );
            // link.download = selectedReportType.label; // Suggests a file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((error) => {
          Swal.fire({
            width: "500px",
            icon: "error",
            title: "<strong><font size='36px'>Error</font></strong>",
            html: "<font size='4px'>Submitted claims found for this organization. Please resolve the submitted claims before proceeding.</font>",
            showConfirmButton: true,
          });
        });
      setIsLoading(false);
    }
  };

  const disablePastDt = (current) => {
    return current.isAfter(selectedStartDate);
  };

  return (
    <div className="main-content">
      <Grid fluid>
        {errorAlert}
        {/* <NotificationSystem ref="notificationSystem" style={style} /> */}

        <Row>
          <Col md={6} style={{ alignItems: "center" }}>
            <Card
              content={
                <Row>
                  <Col md={10}>
                    <FormGroup>
                      <ControlLabel>Select Organization</ControlLabel>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Select Organization"
                        //style={{ width:"10%" }}
                        name="organization"
                        value={selectedOrganization}
                        onChange={(value) => selectOrganization(value)}
                        options={organizationOption}
                      />
                      {errorValidate.organizationError}
                    </FormGroup>
                  </Col>
                  <Col md={10}>
                    <FormGroup>
                      <ControlLabel>Select Type</ControlLabel>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Select Report Type"
                        //style={{ width:"10%" }}
                        name="organization"
                        value={selectedReportType}
                        onChange={(value) => handleOnReportTypeChange(value)}
                        options={claimReportTypeOption}
                      />
                      {errorValidate.reportTypeError}
                    </FormGroup>
                  </Col>
                  <Row>
                    <Col md={10}>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>Start Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{ placeholder: "Order Date" }}
                            closeOnSelect={true}
                            value={selectedStartDate}
                            onChange={(value) =>
                              selectStartDate(value, "start")
                            }
                          />
                          {errorValidate.startDateError}
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <ControlLabel>End Date</ControlLabel>
                          <Datetime
                            timeFormat={false}
                            dateFormat="YYYY-MM-DD"
                            inputProps={{ placeholder: "Order Date" }}
                            closeOnSelect={true}
                            onChange={(value) => selectStartDate(value, "end")}
                            isValidDate={disablePastDt}
                            value={selectedEndDate}
                          />
                          {errorValidate.endDateError}
                        </FormGroup>
                      </Col>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <Row>
                    <Col md={12} style={{ marginTop: "15px" }}>
                      <Col md={3}>
                        <Button onClick={() => onSubmit()}>Download</Button>
                      </Col>
                    </Col>
                  </Row>
                </Row>
              }
            />
          </Col>
        </Row>
      </Grid>
      {isLoading ? <ScreenLoader /> : ""}
    </div>
  );
};

export default ClaimReport;
